// CSV Parser utility for Porsche pricing data

// Since we can't easily import CSV as raw text in this setup,
// we'll fetch it at runtime or embed the data directly
export async function parsePorschePricingCSV() {
  try {
    // Try to fetch the CSV file from public directory
    const response = await fetch("/porsche-pricing-export.csv");

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const csvData = await response.text();

    const lines = csvData.trim().split("\n");

    const headers = parseCSVLine(lines[0]); // Use the same CSV parsing function for headers

    const data = [];

    for (let i = 1; i < lines.length; i++) {
      const values = parseCSVLine(lines[i]);
      const row = {};

      headers.forEach((header, index) => {
        // Clean header names (remove quotes and spaces)
        const cleanHeader = header.replace(/"/g, "").trim();
        let value = values[index] || "";

        // Remove quotes from values
        if (
          typeof value === "string" &&
          value.startsWith('"') &&
          value.endsWith('"')
        ) {
          value = value.slice(1, -1);
        }

        // Convert numeric fields
        if (
          cleanHeader === "Kleine Inspektion Min" ||
          cleanHeader === "Grosse Inspektion Min"
        ) {
          value = parseInt(value) || 0;
        }

        row[cleanHeader] = value;
      });

      data.push(row);
    }

    return data;
  } catch (error) {
    console.error("Error loading CSV data:", error);
    return [];
  }
}

// Helper function to parse CSV line considering quoted values
function parseCSVLine(line) {
  const result = [];
  let current = "";
  let inQuotes = false;

  for (let i = 0; i < line.length; i++) {
    const char = line[i];

    if (char === '"') {
      inQuotes = !inQuotes;
    } else if (char === "," && !inQuotes) {
      result.push(current);
      current = "";
    } else {
      current += char;
    }
  }

  result.push(current); // Add the last field
  return result;
}

// Function to group CSV data into hierarchical structure like the original JSON
export async function groupPorscheData() {
  const csvData = await parsePorschePricingCSV();
  const grouped = {};

  csvData.forEach((row) => {
    const modelKey = row["Model Key"];
    const generationKey = row["Generation Key"];
    const variantKey = row["Variant Key"];

    // Initialize model if it doesn't exist
    if (!grouped[modelKey]) {
      grouped[modelKey] = {
        displayName: row["Model"],
        generations: {},
      };
    }

    // Initialize generation if it doesn't exist
    if (!grouped[modelKey].generations[generationKey]) {
      grouped[modelKey].generations[generationKey] = {
        name: row["Generation"],
        displayName: row["Generation"],
        years: row["Years"],
        category: row["Category"],
        variants: {},
      };
    }

    // Add variant
    grouped[modelKey].generations[generationKey].variants[variantKey] = {
      name: row["Variant"],
      engine: row["Engine"],
      power: row["Power"],
      years: row["Years"],
      multiplier: row["Multiplier"],
      searchTerms: row["Search Terms"] ? row["Search Terms"].split("; ") : [],
      notes: row["Notes"] ? row["Notes"].split(", ") : [], // Notes column may not exist in v2
      pricing: {
        kleine: {
          min: row["Kleine Inspektion Min"],
        },
        grosse: {
          min: row["Grosse Inspektion Min"],
        },
      },
    };
  });

  return grouped;
}

// Alternative: Function to get flat array of all variants for simpler processing
export function getFlatVariantData() {
  return parsePorschePricingCSV();
}
